import { BaseScreen } from "./BaseScreen";

import { BackHeader } from "./components/BackHeader";

import { TitleBlock } from "../blocks/TitleBlock";
import { ProductTitleBlock } from "../blocks/ProductTitleBlock";
import { SubscriptionTransitionBlock } from "../blocks/subscriptions/SubscriptionTransitionBlock";

import type { Block } from "../blocks/Block";

import type { HeaderEvents } from "./components/HeaderEvents";
import type { StateStore } from "../app/state/StateStore";
import type { SubscriptionChangeActions } from "./components/SubscriptionChangeActions";
import type { Screen } from "../app/api/ApiClient";

type ConfirmChangeScreenModel =
    Extract<Screen, { type: "confirmChange" }>;

export class ConfirmChangeScreen
    extends BaseScreen {

    private readonly screen: ConfirmChangeScreenModel;

    private readonly store: StateStore;

    private readonly headerEvents: HeaderEvents;

    private readonly actions: SubscriptionChangeActions;

    private readonly blocks: Block[] = [];

    private root!: HTMLElement;

    constructor(
        screen: ConfirmChangeScreenModel,
        store: StateStore,
        headerEvents: HeaderEvents,
        actions: SubscriptionChangeActions
    ) {
        console.log(
    "CONFIRM SCREEN",
    screen
);
        super();

        this.screen = screen;
        this.store = store;
        this.headerEvents = headerEvents;
        this.actions = actions;

    }

    public override mount(): void {

        super.mount();

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        super.update();

        for (const block of this.blocks) {
            block.unmount();
        }

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =====================================================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "confirm-change-screen";

        const header =
            new BackHeader(
                this.headerEvents
            );

        header.mount();

        root.appendChild(
            header.getRoot()
        );

        root.style.paddingTop =
            "70px";

        const container =
            document.createElement("div");

        container.className =
            "subscriptions-container";

        root.appendChild(
            container
        );

        this.buildBlocks();

        for (const block of this.blocks) {

            block.mount();

            container.appendChild(
                block.getRoot()
            );

        }

        return root;

    }

    private buildBlocks(): void {

        this.blocks.length = 0;

        this.blocks.push(

            new TitleBlock(

                "Підтвердження зміни підписки"

            )

        );

        this.blocks.push(

            new ProductTitleBlock(

                this.screen.product_title

            )

        );

        this.blocks.push(

            new SubscriptionTransitionBlock(

            this.screen,

            this.actions,

            this.headerEvents

        )

        );

    }

}